// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--bg-primary);
}

.App.header-layout {
  /* Header layout: header at top, sidebars visible on sides */
  padding-top: 60px; /* Space for fixed header */
  display: grid;
  grid-template-columns: 280px 1fr 350px;
  grid-template-rows: auto 1fr;
  gap: 0;
  grid-template-areas:
    "left header right"
    "left content right";
}

.App.header-layout .header {
  grid-area: header;
}

.App.header-layout .main-content {
  grid-area: content;
}

.App.header-layout .sidebar-wrapper.left {
  grid-area: left;
  display: flex;
}

.App.header-layout .sidebar-wrapper.right {
  grid-area: right;
  display: flex;
}

.App.sidebar-layout {
  /* Sidebar layout: sidebars on sides, feed-stick at top */
  padding-top: 0;
}

/* Layout container for sidebars and main content (below header) */
.app-layout {
  display: flex;
  flex: 1 1;
  position: relative;
}

.main-content {
  flex: 1 1;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
}

/* Wide maincontent mode: increase page container width */
:root[data-maincontent="wide"] .main-content {
  max-width: 100%;
}

/* Create-article routes: fill the full center column between sidebars */
.main-content.full-width-content {
  max-width: 100%;
}

/* Route Loading Overlay */
.route-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  opacity: 0.95;
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
}

/* Sidebar Wrapper */
.sidebar-wrapper {
  transition: transform 0.3s ease;
  display: contents;
}

.sidebar-wrapper.left,
.sidebar-wrapper.right {
  display: contents;
}

/* Sidebar Backdrop */
.sidebar-backdrop {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Header Layout Specific */
.App.header-layout {
  display: flex;
  flex-direction: row;
  padding-top: 60px; /* Space for header */
}

.App.header-layout .header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
}

.App.header-layout .main-content {
  flex: 1 1;
  padding-top: 0; /* Feed stick will be sticky relative to main-content */
}

.App.header-layout .feed-stick {
  position: sticky;
  top: 60px; /* Stick below header */
  z-index: 100;
}

/* Sidebars visible in all layouts */
.App.header-layout .sidebar-wrapper {
  display: none;
}

.App.header-layout .sidebar-wrapper.left {
  /* Hidden by default, shown on desktop */
  width: 280px;
  overflow-y: auto;
}

.App.header-layout .sidebar-wrapper.right {
  /* Hidden by default, shown on desktop */
  width: 350px;
  overflow-y: auto;
}

/* Desktop: Show sidebars on the sides */
@media (min-width: 1216px) {
  .App.header-layout .sidebar-wrapper {
    display: flex;
  }
}

/* Tablet/mobile in header layout: sidebars open as slide-in drawers */
@media (max-width: 1215px) {
  .sidebar-backdrop {
    display: block;
  }

  .App.header-layout .sidebar-wrapper.left,
  .App.header-layout .sidebar-wrapper.right {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1000;
  }

  .App.header-layout .sidebar-wrapper.left {
    left: 0;
    transform: translateX(-100%);
  }

  .App.header-layout .sidebar-wrapper.left.open {
    transform: translateX(0);
  }

  .App.header-layout .sidebar-wrapper.right {
    right: 0;
    transform: translateX(100%);
  }

  .App.header-layout .sidebar-wrapper.right.open {
    transform: translateX(0);
  }
}

/* Sidebar Layout Specific */
.App.sidebar-layout .feed-stick {
  position: sticky;
  top: 0;
  z-index: 100;
}

/* Responsive Design */
@media (max-width: 768px) {
  .app-layout {
    flex-direction: column;
  }
  
  .main-content {
    margin-left: 0;
    max-width: 100%;
  }
  
  .mobile-menu-toggle {
    display: flex;
  }
  
  .sidebar-backdrop {
    display: block;
  }
  
  .sidebar-wrapper.left,
  .sidebar-wrapper.right {
    display: block;
  }
  
  .sidebar-wrapper.left {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1000;
    transform: translateX(-100%);
  }
  
  .sidebar-wrapper.left.open {
    transform: translateX(0);
  }
  
  .sidebar-wrapper.right {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    transform: translateX(100%);
  }
  
  .sidebar-wrapper.right.open {
    transform: translateX(0);
  }

  /* Header layout on mobile */
  .App.header-layout .sidebar-wrapper.left {
    display: block;
  }

  .App.header-layout .sidebar-wrapper.right {
    display: block;
  }

  .App.header-layout .feed-stick {
    top: 60px;
  }
}

/* Distraction-less Reading Mode */
body.distraction-less-reading .sidebar-wrapper,
body.distraction-less-reading .header-wrapper,
body.distraction-less-reading .mobile-menu-toggle {
  display: none !important;
}

body.distraction-less-reading .App.header-layout {
  padding-top: 0;
}

body.distraction-less-reading .main-content {
  max-width: 100%;
  margin: 0 auto;
}

body.distraction-less-reading .app-layout {
  padding: 0;
}

.slider-actions .confirm-btn {
  padding: 12px 20px;
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  color: var(--text-primary);
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
  display: block;
  align-items: center;
  background-color: var(--primary-color);
}

.slider-actions .confirm-btn:hover {
  background-color: var(--primary-hover);
  border-color: var(--accent-primary);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,4DAA4D;EAC5D,iBAAiB,EAAE,2BAA2B;EAC9C,aAAa;EACb,sCAAsC;EACtC,4BAA4B;EAC5B,MAAM;EACN;;wBAEsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yDAAyD;EACzD,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAE,qBAAqB;AAC1C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,cAAc,EAAE,uDAAuD;AACzE;;AAEA;EACE,gBAAgB;EAChB,SAAS,EAAE,uBAAuB;EAClC,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa;EACf;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;IACd,eAAe;IACf,MAAM;IACN,SAAS;IACT,aAAa;EACf;;EAEA;IACE,OAAO;IACP,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,4BAA4B;EAC5B;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,kCAAkC;AAClC;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC","sourcesContent":["body {\r\n  margin: 0;\r\n  padding: 0;\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n.App {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  background-color: var(--bg-primary);\r\n}\r\n\r\n.App.header-layout {\r\n  /* Header layout: header at top, sidebars visible on sides */\r\n  padding-top: 60px; /* Space for fixed header */\r\n  display: grid;\r\n  grid-template-columns: 280px 1fr 350px;\r\n  grid-template-rows: auto 1fr;\r\n  gap: 0;\r\n  grid-template-areas:\r\n    \"left header right\"\r\n    \"left content right\";\r\n}\r\n\r\n.App.header-layout .header {\r\n  grid-area: header;\r\n}\r\n\r\n.App.header-layout .main-content {\r\n  grid-area: content;\r\n}\r\n\r\n.App.header-layout .sidebar-wrapper.left {\r\n  grid-area: left;\r\n  display: flex;\r\n}\r\n\r\n.App.header-layout .sidebar-wrapper.right {\r\n  grid-area: right;\r\n  display: flex;\r\n}\r\n\r\n.App.sidebar-layout {\r\n  /* Sidebar layout: sidebars on sides, feed-stick at top */\r\n  padding-top: 0;\r\n}\r\n\r\n/* Layout container for sidebars and main content (below header) */\r\n.app-layout {\r\n  display: flex;\r\n  flex: 1;\r\n  position: relative;\r\n}\r\n\r\n.main-content {\r\n  flex: 1;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n/* Wide maincontent mode: increase page container width */\r\n:root[data-maincontent=\"wide\"] .main-content {\r\n  max-width: 100%;\r\n}\r\n\r\n/* Create-article routes: fill the full center column between sidebars */\r\n.main-content.full-width-content {\r\n  max-width: 100%;\r\n}\r\n\r\n/* Route Loading Overlay */\r\n.route-loading-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: var(--bg-primary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 100;\r\n  opacity: 0.95;\r\n}\r\n\r\n/* Mobile Menu Toggle */\r\n.mobile-menu-toggle {\r\n  display: none;\r\n}\r\n\r\n/* Sidebar Wrapper */\r\n.sidebar-wrapper {\r\n  transition: transform 0.3s ease;\r\n  display: contents;\r\n}\r\n\r\n.sidebar-wrapper.left,\r\n.sidebar-wrapper.right {\r\n  display: contents;\r\n}\r\n\r\n/* Sidebar Backdrop */\r\n.sidebar-backdrop {\r\n  display: none;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 999;\r\n}\r\n\r\n/* Header Layout Specific */\r\n.App.header-layout {\r\n  display: flex;\r\n  flex-direction: row;\r\n  padding-top: 60px; /* Space for header */\r\n}\r\n\r\n.App.header-layout .header {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 200;\r\n}\r\n\r\n.App.header-layout .main-content {\r\n  flex: 1;\r\n  padding-top: 0; /* Feed stick will be sticky relative to main-content */\r\n}\r\n\r\n.App.header-layout .feed-stick {\r\n  position: sticky;\r\n  top: 60px; /* Stick below header */\r\n  z-index: 100;\r\n}\r\n\r\n/* Sidebars visible in all layouts */\r\n.App.header-layout .sidebar-wrapper {\r\n  display: none;\r\n}\r\n\r\n.App.header-layout .sidebar-wrapper.left {\r\n  /* Hidden by default, shown on desktop */\r\n  width: 280px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.App.header-layout .sidebar-wrapper.right {\r\n  /* Hidden by default, shown on desktop */\r\n  width: 350px;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Desktop: Show sidebars on the sides */\r\n@media (min-width: 1216px) {\r\n  .App.header-layout .sidebar-wrapper {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n/* Tablet/mobile in header layout: sidebars open as slide-in drawers */\r\n@media (max-width: 1215px) {\r\n  .sidebar-backdrop {\r\n    display: block;\r\n  }\r\n\r\n  .App.header-layout .sidebar-wrapper.left,\r\n  .App.header-layout .sidebar-wrapper.right {\r\n    display: block;\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    z-index: 1000;\r\n  }\r\n\r\n  .App.header-layout .sidebar-wrapper.left {\r\n    left: 0;\r\n    transform: translateX(-100%);\r\n  }\r\n\r\n  .App.header-layout .sidebar-wrapper.left.open {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .App.header-layout .sidebar-wrapper.right {\r\n    right: 0;\r\n    transform: translateX(100%);\r\n  }\r\n\r\n  .App.header-layout .sidebar-wrapper.right.open {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n/* Sidebar Layout Specific */\r\n.App.sidebar-layout .feed-stick {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .app-layout {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .main-content {\r\n    margin-left: 0;\r\n    max-width: 100%;\r\n  }\r\n  \r\n  .mobile-menu-toggle {\r\n    display: flex;\r\n  }\r\n  \r\n  .sidebar-backdrop {\r\n    display: block;\r\n  }\r\n  \r\n  .sidebar-wrapper.left,\r\n  .sidebar-wrapper.right {\r\n    display: block;\r\n  }\r\n  \r\n  .sidebar-wrapper.left {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    z-index: 1000;\r\n    transform: translateX(-100%);\r\n  }\r\n  \r\n  .sidebar-wrapper.left.open {\r\n    transform: translateX(0);\r\n  }\r\n  \r\n  .sidebar-wrapper.right {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 1000;\r\n    transform: translateX(100%);\r\n  }\r\n  \r\n  .sidebar-wrapper.right.open {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  /* Header layout on mobile */\r\n  .App.header-layout .sidebar-wrapper.left {\r\n    display: block;\r\n  }\r\n\r\n  .App.header-layout .sidebar-wrapper.right {\r\n    display: block;\r\n  }\r\n\r\n  .App.header-layout .feed-stick {\r\n    top: 60px;\r\n  }\r\n}\r\n\r\n/* Distraction-less Reading Mode */\r\nbody.distraction-less-reading .sidebar-wrapper,\r\nbody.distraction-less-reading .header-wrapper,\r\nbody.distraction-less-reading .mobile-menu-toggle {\r\n  display: none !important;\r\n}\r\n\r\nbody.distraction-less-reading .App.header-layout {\r\n  padding-top: 0;\r\n}\r\n\r\nbody.distraction-less-reading .main-content {\r\n  max-width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\nbody.distraction-less-reading .app-layout {\r\n  padding: 0;\r\n}\r\n\r\n.slider-actions .confirm-btn {\r\n  padding: 12px 20px;\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  color: var(--text-primary);\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  text-decoration: none;\r\n  display: block;\r\n  align-items: center;\r\n  background-color: var(--primary-color);\r\n}\r\n\r\n.slider-actions .confirm-btn:hover {\r\n  background-color: var(--primary-hover);\r\n  border-color: var(--accent-primary);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
